/** @jsxImportSource theme-ui */
import { Box, Flex, Heading } from 'theme-ui';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetCompanyInvoicesQuery } from '@/store/apiService';
import DataTable from '@/components/DataTable';
import Button from '@/components/Button';
import { format } from 'date-fns';

const columns = [
    { columnKey: 'Id', accessor: 'Id', Header: 'Id' },
    {
        columnKey: 'PeriodFrom',
        accessor: 'PeriodFrom',
        Header: 'Period from',
        Cell: ({ row }) => format(new Date(row.original.PeriodFrom), 'd MMM yyyy'),
    },
    {
        columnKey: 'PeriodTo',
        accessor: 'PeriodTo',
        Header: 'Period to',
        Cell: ({ row }) => format(new Date(row.original.PeriodTo), 'd MMM yyyy'),
    },
    {
        columnKey: 'DueDate',
        accessor: 'DueDate',
        Header: 'Due date',
        Cell: ({ row }) => format(new Date(row.original.DueDate), 'd MMM yyyy'),
    },
    {
        columnKey: 'Last activity',
        accessor: 'Updated',
        Header: 'Last activity',
        Cell: ({ row }) => format(new Date(row.original.Updated), 'd MMM yyyy'),
    },
];

const CompanyInvoices = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const companyInvoices = useGetCompanyInvoicesQuery({ CompanyId: id });

    return (
        <Box>
            <Flex sx={{ justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                <Heading>Company invoices</Heading>
                <Button
                    variant="secondary"
                    disabled={!id}
                    onClick={() => navigate(`/clients/${id}/createusage`)}
                >
                    Create usage
                </Button>
            </Flex>
            <Box
                variant="segment"
                sx={{
                    borderRadius: 'sm',
                    overflowY: 'scroll',
                    zIndex: 2,
                    justifySelf: 'left',
                    width: '100%',
                    backgroundColor: 'background',
                    padding: 2,
                    position: 'relative',
                    table: {
                        display: 'block',
                        overflowX: 'auto',
                        whiteSpace: 'nowrap',
                    },
                    thead: {
                        textAlign: 'center',
                    },
                }}
            >
                <DataTable
                    data={companyInvoices?.data?.Results}
                    columns={columns}
                    isLoading={companyInvoices.isLoading}
                    isFetching={companyInvoices.isFetching}
                />
            </Box>
        </Box>
    );
};

export default CompanyInvoices;
